"use client";

import {
  FeatureFlagProvider,
  FiatPricingProvider,
  PassportProvider,
  QueryProvider,
  RouteProvider,
} from "@/context";
import { AnalyticsProvider } from "@/context/AnalyticsProvider";
import { AssetImportProvider } from "@/context/AssetImportProvider";
import { BrazeProvider } from "@/context/BrazeProvider";
import { PWAInstallProvider } from "@/context/PWAInstallContext";
import { PreferencesProvider } from "@/context/PreferencesProvider";
import { ProfileDrawerProvider } from "@/context/ProfileDrawerContext";
import theme from "@/styles/theme";
import { ThemeProvider } from "@mui/material/styles";
import type { ReactNode } from "react";

export function ClientProviders({ children }: { children: ReactNode }) {
  return (
    <RouteProvider>
      <PWAInstallProvider>
        <AnalyticsProvider>
          <PassportProvider>
            <FeatureFlagProvider>
              <QueryProvider>
                <PreferencesProvider>
                  <FiatPricingProvider>
                    <AssetImportProvider>
                      <ProfileDrawerProvider>
                        <BrazeProvider>
                          <ThemeProvider theme={theme}>
                            {children}
                          </ThemeProvider>
                        </BrazeProvider>
                      </ProfileDrawerProvider>
                    </AssetImportProvider>
                  </FiatPricingProvider>
                </PreferencesProvider>
              </QueryProvider>
            </FeatureFlagProvider>
          </PassportProvider>
        </AnalyticsProvider>
      </PWAInstallProvider>
    </RouteProvider>
  );
}
